<template>
    <div class="modal">
        <div class="modal-content">
            

            <div>
                <div v-if="isSmallScreen" class="container">
                    <left><span class="close" @click="close">&times;</span></left>
                    
                    <div class="inner">
                        <div class="thumbnail">
                            <div class="thumb">
                                <img :src="imageSrc" @error="handleError" alt="Dynamic Image" class="circle-img">
                            </div>
                        </div>
                    </div>
                    <br>
                    <h3 class="heading-title">{{ record.中文姓名 }} {{ record.英文姓名 }}</h3>
                    <ul class="address-list">
                        <li>                                            
                            <div class="row">
                                <div class="col-sm-3">主奏樂器:</div>
                                <div class="col-sm-9"><h5>{{ record.主奏樂器 }}</h5></div>
                            </div>
                            <div class="row">
                                <div class="col-sm-3">其他樂器:</div>
                                <div class="col-sm-9"><h5>{{ record.其他樂器 }}</h5></div>
                            </div>
                            <div class="row">
                                <div class="col-sm-3">入團年份:</div>
                                <div class="col-sm-9"><h5>{{ record.入團年份 }}</h5></div>
                            </div>
                            <div class="row">
                                <div class="col-sm-3">所屬教會:</div>
                                <div class="col-sm-9"><h5>{{ record.所屬教會 }}</h5></div>
                            </div>
                        <!--
                            <div class="row">
                                <div class="col-sm-3">其他樂團經驗:</div>
                                <div class="col-sm-9"><h5>{{ record.其他樂團經驗 }}</h5></div>
                            </div>
                            <div class="row">
                                <div class="col-sm-3">職業:</div>
                                <div class="col-sm-9"><h5>{{ record.職業 }}</h5></div>
                            </div>
                            <div class="row">
                                <div class="col-sm-3">其他嗜好:</div>
                                <div class="col-sm-9"><h5>{{ record.其他嗜好 }}</h5></div>
                            </div>
                        -->
                        </li>
                    </ul>
                </div>

                <div v-else class="container">
                    <left><span class="close" @click="close">&times;</span></left>
                    <div class="row justify-content-center">
                        <div class="col-xl-12">
                            <div class="contact-me">
                                <div class="inner">
                                    <div class="inner">
                                        <div class="thumbnail">
                                            <div class="thumb">
                                                <img :src="imageSrc" @error="handleError" alt="Dynamic Image">
                                            </div>
                                            <ul class="shape-group">
                                                <MouseMove addClassName="shape-1" dataDepth="1.4" imgSrc="/images/about/shape-13.png" />
                                                <MouseMove addClassName="shape-2" dataDepth="-1.4" imgSrc="/images/counterup/shape-02.png" />
                                                <li class="shape-3">
                                                    <img src="/images/about/shape-07.png" alt="Shape">
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div class="contact-us-info">
                                        <h3 class="heading-title">{{ record.中文姓名 }}</h3>
                                        <h5 class="heading-title">{{ record.英文姓名 }}</h5>
                                        <ul class="address-list">
                                                                                        
                                                <div class="row">
                                                    <div class="col-sm-3">主奏樂器:</div>
                                                    <div class="col-sm-9"><h5>{{ record.主奏樂器 }}</h5></div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-sm-3">其他樂器:</div>
                                                    <div class="col-sm-9"><h5>{{ record.其他樂器 }}</h5></div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-sm-3">入團年份:</div>
                                                    <div class="col-sm-9"><h5>{{ record.入團年份 }}</h5></div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-sm-3">所屬教會:</div>
                                                    <div class="col-sm-9"><h5>{{ record.所屬教會 }}</h5></div>
                                                </div>
                                                
                                                <div class="row">
                                                    <div class="col-sm-3">其他樂團經驗:</div>
                                                    <div class="col-sm-9"><h5>{{ record.其他樂團經驗 }}</h5></div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-sm-3">職業:</div>
                                                    <div class="col-sm-9"><h5>{{ record.職業 }}</h5></div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-sm-3">其他嗜好:</div>
                                                    <div class="col-sm-9"><h5>{{ record.其他嗜好 }}</h5></div>
                                                </div>
                                                
                                            
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <span class="close" @click="close">&times;</span>

        </div>
    </div>
</template>

<script>
export default {
    props: ['record'],

    data() {
        return {
            isSmallScreen: window.innerWidth < 450,
            defaultImage: '/images/hkcco/defaultmember.png', // Fallback image
            imageSrc: '/images/members/' + this.record.中文姓名 + '.jpg'
        };
    },

    mounted() {
        window.addEventListener('resize', this.handleResize);
    },

    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
    },

    methods: {
        close() {
            this.$emit('close');
        },

        handleError(event) {
            this.imageSrc = this.defaultImage
        },

        handleResize() {
            this.isSmallScreen = window.innerWidth < 450;
            console.log("isSmallScreen: + " + window.innerWidth)
        }
    }

};
</script>

<style scoped>
.circle-img {
    width: 200px;          /* set desired size */
    height: 200px;
    border-radius: 50%;    /* makes it a perfect circle */
    object-fit: cover;     /* ensures the image fills the circle without distortion */
    border: 3px solid #555;/* optional border */
}
.modal {
    display: block;
    position: fixed;
    z-index: 1000;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: rgba(0,0,0,0.4);
}
.modal-content {
    background-color: white;
    margin: 15% auto;
    padding: 20px;
    border: 1px solid #888;
    width: 80%;
    border-radius: 10px;
    position: relative;
    top: 400px;
    transform: translateY(-50%);
}
.close {
    color: #aaa;
    float: right;
    font-size: 28px;
    font-weight: bold;
}
.close:hover,
.close:focus {
    color: black;
    text-decoration: none;
    cursor: pointer;
}
</style>
